import moment from 'moment';
import { FC, useEffect } from 'react';
import { Col, Row } from 'reactstrap';

import { MinaraInfo, UnicaPayInfo } from '../../types';
import { formatUSDNoDecimals } from '../../../../../helpers/helpers';

export const FuturaMiningHub: FC<any> = ({ data }: { data: MinaraInfo }) => {
  const returnFractions = (limit: number) => {
    switch (limit) {
      case 1200:
        return 4;
      case 2400:
        return 8;
      case 6000:
        return 20;
      case 600:
        return 2;

      default:
        break;
    }
  };
  return (
    <div
      className='d-flex mb-3 mt-2 border border-primary'
      style={{ position: 'relative' }}>
      <img width={200} style={{ marginRight: 20 }} src={data.imageUrl} />
      <div className='flex-column justify-content-between d-flex gap-4'>
        <div className='d-flex'>
          <Col lg={6} className='border-end p-3'>
            <h5 className='text-muted text-uppercase fs-13'>ORDER ID</h5>
            <h4 className='fs-15 mb-0'>{data.id}</h4>
          </Col>
          <Col lg={8} className='border-end p-3'>
            <h5 className='text-muted text-uppercase fs-13'>
              DATE OF PURCHASE
            </h5>
            <h4 className='fs-15 mb-0'>
              {moment(data?.datePaid).format('DD MMM YYYY')}
            </h4>
          </Col>
        </div>
        <div className='w-100'>
          {data?.limit === null ? (
            <h5>Hardware: Unlimited USDT/USDC</h5>
          ) : (
            <div>
              <h5>Hardware: Max Fractions - {returnFractions(data?.limit)}</h5>
              <h5>(Up to {formatUSDNoDecimals(data?.limit)} USDT/USDC)</h5>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
